import { forwardRef } from "react";
import { Select } from "antd/lib";
import classNames from "classnames";
import type { GetRef, SelectProps } from "antd/lib";
import type { ButtonSelectOption as ButtonSelectOptionType } from "./types";
import styles from "./styles.module.scss";
import { ButtonSelectOption } from "./ButtonSelectOption";

export type ButtonSelectProps = {
  options?: ButtonSelectOptionType[];
} & SelectProps;

type SelectRefType = GetRef<typeof Select>;

export const ButtonSelect = forwardRef<SelectRefType, ButtonSelectProps>(
  ({ options, className, disabled, ...props }, ref) => {
    return (
      <Select
        ref={ref}
        className={classNames(styles.select, { [styles.disabled]: disabled }, className)}
        options={options}
        disabled={disabled}
        optionRender={(option) => (
          <ButtonSelectOption
            option={{
              label: option.data.label,
              value: option.data.value,
              icon: option.data?.icon,
            }}
          />
        )}
        {...props}
      />
    );
  },
);
